<template>
		<div class="wrap">
		<div class="searchWrap">
		    <input class="searchIn" type="text"  v-model="searchText" @keyup.enter="getSearch"  placeholder="请输入证件号" @input="inputFun"/>
        <input class="searchIn" type="text" style="margin-top:10px" v-model="docNo" @keyup.enter="getSearch"  placeholder="请输入凭证号" @input="inputFun"/>
		    <el-button type="primary" @click="getSearch()"><span :class="{'el-icon-loading':lodingBtn}"></span> 查询</el-button>
		</div>
		<div class="content content1" v-show="!startSearch">
			<p class="title">欢迎使用保单搜索功能</p>
			<p class="txt"><span></span>在输入框内输入手机号、身份证、护照都可以搜索用户保单</p>
			<p class="txt"><span></span>请保证输入的证件号完整有效</p>
			<p class="txt"><span></span>如果精确搜索，可指定搜索的号码类型</p>
		</div>
		<div class="content content2" v-show="searchNum && startSearch">
			<!-- <p class="title">未搜索到此保单</p> -->
			<img src="./img/none.png" />
			<span class="txt">很抱歉!</span>
			<p class="pTxt">您搜索的“<span>{{searchText}}</span>”未找到对应保单</p>

		</div>
		<div class="content content3" v-show="!searchNum &&startSearch">
			<p class="title">搜素到以下保单</p>
			<ul v-for="item in policies" class="card">
				<div class="info">
					<span class="name">{{item.name}}</span>
					<span class="code">{{item.phoneNo}}</span>
					<!-- <a class="btn">去补充报案信息</a> -->
				</div>
				<li>
					<p class="name">保单名称：</p>
					<p class="txt" v-if="item.productName">{{item.category==6?'VIP权益（'+ item.productName+'）':item.productName}}</p>
					<p class="txt" v-else>{{item.category==6?'VIP权益':item.productName}}</p>
				</li>
        <li>
					<p class="name">保单号：</p>
					<p class="txt">{{item.docNo}}</p>
				</li>
				<li>
					<p class="name">有效期：</p>
					<p class="txt">{{formattingTime(item.validFrom)}}－{{formattingTime(item.validUtil)}}</p>
				</li>
				<li>
					<p class="name">被保人证件号：</p>
					<p class="txt">{{item.nationalId}}</p>
				</li>
				<li>
					<p class="name">承保公司：</p>
					<p class="txt">{{item.company}}</p>
				</li>
				<li>
					<p class="name">售卖渠道：</p>
					<p class="txt">{{item.channelName || '暂无'}}</p>
				</li>
				<li>
					<p class="name">所属分公司：</p>
					<p class="txt">{{item.parentChannelName || '暂无'}}</p>
				</li>
				<li>
					<p class="name">联系人：</p>
					<p class="txt">{{item.parentContactInfo || '暂无'}}</p>
				</li>
				<div class="more">
					<!--<p></p>-->
					<a v-if="item.detailUrl" download="保单详情" :href="item.detailUrl" class="download">下载保单</a>
				</div>
			</ul>

		</div>
	</div>
</template>

<script>
	import { searchInsurPolicy } from '@/views/axios/api.js';
	import constants from "@/util/constants.js";
	export default {
		data() {
			return {
				policies:[],
				token: JSON.parse(window.localStorage.getItem("data")).data,
				searchText:"",
        docNo:'',
				startSearch:false,
				searchNum:false,
				lodingBtn:false
			}
		},
		methods: {
			formattingTime(time) {
				return constants.time(time)
			},
			inputFun(){
				this.startSearch =false
			},
			getSearch() { //获取保单
				if(this.searchText == '' && this.docNo == ""){
					return this.$message.warning('搜索内容不能为空')
				}
				this.startSearch=true;
				this.lodingBtn=true;
				var data = {
					token: this.token,
					hit:this.searchText,
          billNo:this.docNo
				}
				searchInsurPolicy(data)
					.then(res => {
						this.lodingBtn=false
						this.policies = res.data.obj;
						if(this.policies.length == 0){
							this.searchNum=true;
						}	else{
							this.searchNum=false;
						}					
					})
					.catch(err => {
						console.log(err)
					})
			}

		}
	}
</script>

<style scoped="scoped">
	a{text-decoration: none;}
	.wrap{
		width: 100%;
	    height: 425px;
	}
   .wrap .searchWrap{
    	width: 100%; 
    	box-sizing:border-box;
    	padding-left: 60px;
    	height: 40px;
    	
    }
    .searchWrap .searchSe{
    	width: 175px;
		height: 40px;
		background-color: #ffffff;
		border-radius: 5px;
		border: solid 1px #d9ddde;
		box-sizing:border-box;
		outline: none;
		margin-right: 40px;
		font-size: 16px;
		padding-left: 12px;
		cursor: pointer;
    }
     .searchWrap .searchSe option{
        height: 40px;
     }
    .searchWrap .searchIn{
    	width: 620px;
		height: 40px;
		background-color: #ffffff;
		border-radius: 5px;
		border: solid 1px #d9ddde;
		box-sizing:border-box;
		padding-left: 12px;
		outline: none;
		margin-right: 40px;
		font-size: 16px;
    }
    .searchWrap .searchBt{
    	width: 100px;
		height: 40px;
		background-color: #00abfa;
		border-radius: 5px;
		border: solid 1px #d9ddde;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		color: #ffffff;
		border:none;
		cursor: pointer;
       /* display: none;*/

    }
    .searchWrap .search_load{
    	display: inline-block;
    	width: 100px;
		height: 40px;
		background-color: #00abfa;
		border-radius: 5px;
		border: solid 1px #d9ddde;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		color: #ffffff;
		border:none;
		font-size: 18px;
		display: none;     
    } 
    .searchWrap .search_load span{

    }
    .searchWrap .search_load img{
    
    }
    .wrap .content{
    	width: 100%;
    }
    .wrap .content1 .title{
    	padding-top: 100px;
    	width: 100%;
    	text-align: center;
    	font-size: 18px;
    	color: #666;
    	font-weight: bold;
    	margin-bottom: 20px;
    }
	.content1 .txt {
		font-size: 16px;
		color: #666;
		box-sizing:border-box;
		padding-left: 245px;
		margin-bottom: 15px;
		position: relative;
	}
	.content1 .txt span{
		left: 210px;
		top: -10px;
		position: absolute;
	}
	.content1 .txt span::before,.content1 .txt span::after{
		content:"";
        height:19px;
        width:3px;
        border-radius: 10px;
        display:block;
        background:#00abfa;
        position: absolute;
        top:12px;/*40-6=34*/
        left:17px;/*make the two rects in the middle of the cycle */
        transform:rotate(45deg);    
        -ms-transform:rotate(45deg);
	}
    .content1 .txt span::before{
        height:9px;
        transform: rotate(-45deg);
        -ms-transform:rotate(-45deg);
        position: absolute;
        top:19px;/*40-18=12  */
        left:8px;       
    }
    .content2 .title{
    	padding-top: 20px;
    	width: 100%;
    	text-align: center;
    	font-size: 16px;
    	color: rgba(223, 23, 23, 0.6);
    }
    .content2 img{
    	width: 120px;
      display: block;
			margin: 0 auto;
			margin-top: 100px;
    }
    .content2 .txt{
    	font-size: 16px;
	    color: #999999;
	    width: 100%;
	    text-align: center;
	    margin-top: 20px;
	    display: block;
    }
    .content2 .pTxt{
    	font-size: 16px;
	    color: #999999;
	    width: 100%;
	    text-align: center;
	    margin-top: 13px;
    }
    .content2 .pTxt span{
    	color: #df1717;
    }
    .content3 .title{
    	padding-top: 20px;
    	width: 100%;
    	text-align: center;
    	font-size: 16px;
    	color: rgba(45, 170, 100, 0.6);
    }
    .content3 .card{
    	width: 756px;
    	margin: 0 auto;
    	margin-top: 56px;
    }
    .card > div.info{
    	overflow: hidden;
    	height: 34px;
    	width: 100%;  
    	margin-bottom: 10px; 	
    }
    .card > div.info > span{
    	display: block;
    	float: left;
    	text-align: center;
    	font-weight: bold;
    	font-size: 20px;
    	color: #333;
    	line-height: 34px;
    	height: 34px;
    }
    .card > div.info > span.name{
    	width: 140px;  	
    }
    .card > div.info > span.code{
    	width: 218px;
    }
    .card > div.info > a{
    	display: block;
    	float: right;
    	height: 34px;
    	width: 150px;
    	font-size: 16px;
    	color: #c27506;
    	background-color: #f8dc40;
	    border-radius: 5px;
	    text-align: center;
	    line-height: 34px;
	    cursor: pointer;
    }
    .card li{
    	width: 100%;
    	height: 44px;
    	position: relative;
    	font-size: 16px;
    }
    .card li > p.name{
    	position: absolute;
    	left: 60px;
    	height: 44px;
    	line-height: 44px;
    	width: 98px;
      font-size: 14px;
    	color: #999;
    }
    .card li > p.txt{
        height: 44px;
    	line-height: 44px;
    	margin-left: 155px;
    	color: #333;
    }
    .card > .more{
    	margin-top: 14px;
    	height: 34px;
    	overflow: hidden;
    }
    .card > .more p{
        padding-left: 60px;
        color: #00abfa;
        height:34px;
        line-height: 34px;
        float: left;
    }
    .card > .more a{
    	width: 91px;
		height: 32px;
		line-height: 32px;
		background-color: #ffffff;
		border-radius: 5px;
		border: solid 1px #00abfa;
		color: #00abfa;
		float: left;
		text-align: center;
		margin-left: 35px;
		cursor: pointer;
    }
    .content3{
    	overflow-y: scroll;
    	height:340px;
    	margin-top: 70px;
    }	
</style>


// WEBPACK FOOTER //
// src/views/cmd_center/monitoringCase/searchBd.vue